import { StateService } from "@core-services/state.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PortfolioPerformance } from "@modules/portfolio/domain/entities/portfolio-performance.model";

export interface PortfolioPerformanceState extends PortfolioPerformance {
	error: boolean;
	isLoading: boolean;
}

@Injectable({
	providedIn: "root"
})
export class PortfolioPerformanceStateService extends StateService<PortfolioPerformanceState> {
	public constructor() {
		super(null);
	}

	public getState$(): Observable<PortfolioPerformanceState> {
		return this.select((state) => state);
	}

	public updateState(model: PortfolioPerformanceState): void {
		this.setState(model);
	}

	public performanceErrorState(): void {
		this.updateState({
			timeframe: "",
			data: [],
			asset_group_performances: [],
			overall_portfolio_current_value: "",
			return_percentage: "",
			error: true,
			isLoading: false
		});
	}

	public hasError(): boolean {
		return this.state?.error;
	}

	public isPerformanceLoaded(): boolean {
		return this.isStateLoaded();
	}

	public setIsLoading(isLoading: boolean): void {
		this.setState({
			isLoading: isLoading
		});
	}
}
